import { render } from "./SpotPos.vue?vue&type=template&id=45591128"
import script from "./SpotPos.vue?vue&type=script&lang=js"
export * from "./SpotPos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__